import { Action, createAction, handleActions } from 'redux-actions'
import { takeLatest } from 'redux-saga/effects'
import { oc } from 'ts-optchain'

import { fetchScheduleList } from '@/api/SchedulePaymentApi'
import { IPageInfoRequest, IPageInfoResponse } from '@/domains/CommonDomain'
import { EmptyScheduledTransfer, IScheduledTransfer } from '@/domains/SchedulePaymentDomain'
import { IRootState } from '@/modules'
import { createFetchAction, createSaga } from '@/utils/actionUtils'
import { apiFailureReducer, increasePage, reset } from '@/utils/reducerUtils'

export interface ISchedulePaymentState {
  scheduledTransfers: IScheduledTransfer[]
  pageInfo: IPageInfoResponse
}

export const SCHEDULE_PAYMENT = 'SchedulePayment'

const initialState: ISchedulePaymentState = {
  scheduledTransfers: [],
  pageInfo: {
    curPage: 1,
    totCnt: 30,
    totPage: 3,
  },
}

const INCREASE_PAGE = `${SCHEDULE_PAYMENT}/increasePage`
const RESET_STATE = `${SCHEDULE_PAYMENT}/resetState`

export const schedulePaymentActions = {
  increasePage: createAction(INCREASE_PAGE),
  resetState: createAction(RESET_STATE),
}
export const schedulePaymentAsync = createFetchAction<IPageInfoRequest>(SCHEDULE_PAYMENT)

export const reducer = {
  [schedulePaymentAsync.SUCCESS]: (state: ISchedulePaymentState, action: Action<any>) => {
    const { scheduledTransfers = [], pageInfo = state.pageInfo } = action.payload

    return {
      ...state,
      pageInfo,
      scheduledTransfers: state.scheduledTransfers.concat(scheduledTransfers),
    }
  },
  [schedulePaymentAsync.FAILURE]: apiFailureReducer,
  [INCREASE_PAGE]: increasePage,
  [RESET_STATE]: (state: ISchedulePaymentState) =>
    reset<ISchedulePaymentState>(state, initialState),
}

export const schedulePaymentSelector = {
  scheduleList: (state: IRootState) => oc(state[SCHEDULE_PAYMENT]).scheduledTransfers([]),
  scheduledTransfer: (state: IRootState, refNo: string) =>
    oc(state[SCHEDULE_PAYMENT])
      .scheduledTransfers(initialState.scheduledTransfers)
      .find((item: IScheduledTransfer) => item.refNo === refNo) || EmptyScheduledTransfer,
  scheduleListPageInfo: (state: IRootState) => ({
    curPage: oc(state[SCHEDULE_PAYMENT]).pageInfo.curPage(initialState.pageInfo.curPage),
    totPage: oc(state[SCHEDULE_PAYMENT]).pageInfo.totPage(initialState.pageInfo.totPage),
  }),
}

export const fetchScheduleTransfers = createSaga<IPageInfoRequest>(
  schedulePaymentAsync,
  fetchScheduleList,
)

export const schedulePaymentReducer = handleActions(reducer, initialState)
export const schedulePaymentSaga = [takeLatest(schedulePaymentAsync.FETCH, fetchScheduleTransfers)]
